import React from 'react';
import { Modal as MuiModal, Box } from '@mui/material';

/**
 * Centered MUI modal with the standard backdrop blur + rounded panel. Replaces
 * the copy-pasted `sx={{ display:'flex', alignItems:'center', ... blur }}`
 * blocks scattered across Header.js and other components.
 */
export default function Modal({ open, onClose, children, maxWidth = 650, panelClassName = '', ...props }) {
  return (
    <MuiModal
      open={open}
      onClose={onClose}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backdropFilter: 'blur(3px)',
        backgroundColor: 'rgba(41, 27, 59, 0.5)',
        zIndex: 1300,
      }}
      {...props}
    >
      <Box
        className={panelClassName}
        sx={{
          borderRadius: 3,
          p: 2,
          maxHeight: '90vh',
          width: '90%',
          maxWidth,
          outline: 'none',
        }}
      >
        {children}
      </Box>
    </MuiModal>
  );
}
